const _ = require("lodash");

// cmp is a function taking two elements. It returns true if the first should
// go later than the second, i.e. first >= second. The final return is a total
// order of the elements respecting the partial order defined by cmp.
const order = function(els, cmp) {
	const n = els.length;
	// earlierThanCache[i].has(j) means i <= j.
	const earlierThanCache = _.range(n).map(() => new Set());
	const laterThanCache = _.range(n).map(() => new Set());
	// Helper which sets a result of a cmp in the cache and finds transitivity.
	// Assumes result is not null and the cache is null at this value.
	const setEarlierThan = (i, j) => {
		earlierThanCache[i].add(j);
		laterThanCache[j].add(i);
		laterThanCache[i].forEach(k => {
			if (!laterThanCache[j].has(k)) {
				setEarlierThan(k, j);
			}
		});
		earlierThanCache[j].forEach(k => {
			if (!earlierThanCache[i].has(k)) {
				setEarlierThan(i, k);
			}
		});
	};
	// Build the entire comparison matrix. This order of doing the comparisons
	// takes advantage of being passed lists that are roughly in order.
	for (let d = 1; d < n; d += 1) {
		for (let i = 0; i + d < n; i += 1) {
			const j = i + d;
			if (!earlierThanCache[i].has(j) && !laterThanCache[i].has(j)) {
				const result = cmp(els[i], els[j]);
				if (result === true) {
					setEarlierThan(j, i);
				} else if (result === false) {
					setEarlierThan(i, j);
				}
			}
		}
	}
	// Now do insertion sort
	const finalIndArray = [];
	for (let i = 0; i < n; i += 1) {
		for (let j = 0; j <= i; j += 1) {
			if (j === i || earlierThanCache[i].has(finalIndArray[j])) {
				finalIndArray.splice(j, 0, i);
				break;
			}
		}
	}
	return finalIndArray.map(i => els[i]);
};

module.exports = {order};
